import { render, staticRenderFns } from "./HrBasicOrg.vue?vue&type=template&id=586e6fcc&scoped=true&"
import script from "./HrBasicOrg.vue?vue&type=script&lang=js&"
export * from "./HrBasicOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586e6fcc",
  null
  
)

export default component.exports